module.exports = __webpack_public_path__ + "static/img/banner-image.14959644.png";